import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements AuthGuard {

  constructor(
    private router:Router
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
     if (sessionStorage.getItem('userDetails') && localStorage.getItem('authToken')) {
      if (state.url.split('/').includes('home')) {
        return true;
      }
      this.router.navigate(['/home/account']);
      return false;
    }
    else if (state.url.split('/').includes('home')) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
